import { render, staticRenderFns } from "./fileSetupList.vue?vue&type=template&id=a436c6ca&scoped=true"
import script from "./fileSetupList.vue?vue&type=script&lang=js"
export * from "./fileSetupList.vue?vue&type=script&lang=js"
import style0 from "./fileSetupList.vue?vue&type=style&index=0&id=a436c6ca&prod&lang=less"
import style1 from "./fileSetupList.vue?vue&type=style&index=1&id=a436c6ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a436c6ca",
  null
  
)

export default component.exports